import { getConfigValue } from '@zonofi/common';
import { useAppSelector } from '../../root/root-types';
import { getToken, getUserData } from '../../auth/slice';
import { JTBDEventType } from '../../auth/model';

// Define a type for event data
export type TrackEventData = {
  [key: string]: unknown;
};

// Add type for window.dataLayer
type WindowWithDataLayer = Window & {
  dataLayer?: Array<Record<string, unknown>>;
};

export const useEventTracking = () => {
  const token = useAppSelector(getToken);
  const baseUrl = getConfigValue('API_ENDPOINT');
  const userData = useAppSelector(getUserData);

  const removeEmptyStrings = (obj: Record<string, unknown>) => {
    return Object.fromEntries(
      Object.entries(obj).filter(([, value]) => value !== '' && value != null)
    );
  };

  const userDataForMixpanel = removeEmptyStrings({
    user_id: userData?.id,
    email: userData?.email,
    name: userData?.firstName,
    fullName:
      userData?.firstName && userData?.lastName
        ? userData?.firstName + ' ' + userData?.lastName
        : '',
    sellerWorkspaceId: userData?.workspaceId,
    phoneNumber: userData?.mobile,
  });

  const trackEvent = (
    event: JTBDEventType,
    data: Record<string, unknown> = {}
  ) => {
    const filteredData = removeEmptyStrings(data || {});
    const combinedData = removeEmptyStrings({
      ...filteredData,
      ...userDataForMixpanel,
    });

    // Remove gstValidTill key from combinedData
    const finalData = { ...combinedData };
    delete finalData['gstValidTill'];

    fetch(`${baseUrl}track`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ eventType: event, event: finalData }),
    });

    fetch(`${baseUrl}trackUser`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(finalData),
    });
    if (
      typeof window !== 'undefined' &&
      (window as WindowWithDataLayer).dataLayer
    ) {
      ((window as WindowWithDataLayer).dataLayer || []).push({
        event,
        data: {
          ...data,
          ...userDataForMixpanel,
        },
      });
    }
  };

  return {
    trackEvent,
  };
};
